module.exports = __webpack_public_path__ + "img/Mask-group1-2.181f6dad.png";